// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1iYPZ","main-image":"Header_main-image__2A99F"};